/* QUESTO FILE CONTIENE UNA SERIE DI COSTANTI E FUNZIONI DI UTILITA'
   USATI PER PERMETTERE L'INTERAZIONE TRA LE APPLICAZIONI AIGRADING E MERCURIO */



/* ************************** FUNZIONI DI UTLITA' ************************** */


// Funzione che permette di refreshare il token jwt che viene usato per effettuare chiamate http autenticate
// da aigrading all'applicazione mercurio
export const refreshJwtToken = (callback) => {
    fetch('/auth/refresh_token', {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
    })
    .then((res) => {
        if (!res.ok) {
            throw Error("An error occurred during token refresh");
        }
        return res.json();
    })
    .then((data) => {
        setJwtToken(data?.token);
        if (callback)
            callback(false, data?.token);
    })
    .catch((error) => {
        console.log(error);
    });
}